import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { readClientPortalRuntimeConfig } from "./env.js";
import "./styles.css";

async function bootClientPortal(): Promise<void> {
  const root = document.getElementById("root");
  if (!root) {
    throw new Error("client_portal_root_missing");
  }
  const variant = readClientPortalRuntimeConfig().portalUiVariant;
  if (variant === "greenfield") {
    await import("@enrein/design-system/workspace-v1.css");
  } else {
    await import("@enrein/design-system/index.css");
    await import("./guided-portal.css");
  }
  createRoot(root).render(<App />);
}

void bootClientPortal();
